module.exports = __webpack_public_path__ + "img/shortcode_paper_wireframe.e8bf4ec7.png";